import { useId } from 'react'

import useModalStack from './useModalStack'

type RenderFn = (close: () => void) => React.ReactNode

type ReturnTuple = [() => void, boolean]

function useModal(renderFn: RenderFn): ReturnTuple {
    const id = useId()

    const { addModal, removeModal, modalIsOpen } = useModalStack()

    const isOpen = modalIsOpen({ id })

    const open = () => {
        addModal({ id, component: renderFn(close) })
    }

    const close = () => {
        removeModal({ id })
    }

    return [open, isOpen]
}

export default useModal
